import { Slider } from '@change/ds-forms';
import { cn } from '@change/ds-utils';

import { useIsMobile } from 'src/app/shared/hooks/userAgent';

import { AmountInput } from '../../AmountInput';
import { ValidationErrorMessage } from '../ValidationErrorMessage';

import { useSliderAmountSelector } from './hooks/useSliderAmountSelector';

export function SliderAmountSelector({
	fullWidth = false,
	showRangeLabels = 'both',
}: {
	fullWidth?: boolean;
	showRangeLabels?: 'maxOnly' | 'both' | 'none';
}): JSX.Element {
	const {
		data: { amount, currencySymbol, placeholder, maxValue, minValue, errorMessage },
		actions: { formatValue, onSliderChange, onSliderChangeEnd, onInputChange, onInputFocus },
	} = useSliderAmountSelector();

	const isMobileDevice = useIsMobile();

	return (
		<div className="mx-auto w-full max-w-2xl">
			<div
				className={cn(
					{
						'pt-2 pr-8 pl-5': !isMobileDevice,
						'sm:pt-2 sm:pr-0': isMobileDevice,
						'pl-0': fullWidth && !isMobileDevice,
					},
					// Reduce padding between slider track and max amount label (override DS track container)
					fullWidth &&
						'[&_[data-qa=slider-amount-selector]_>_div:first-child]:sm:pr-8 [&_[data-qa=slider-amount-selector]_>_div:first-child]:md:pr-2',
					!fullWidth &&
						'[&_[data-qa=slider-amount-selector]_>_div:first-child]:sm:pr-12 [&_[data-qa=slider-amount-selector]_>_div:first-child]:sm:pl-10 [&_[data-qa=slider-amount-selector]_>_div:first-child]:md:px-5',
				)}
			>
				<Slider
					data-qa="slider-amount-selector"
					// TODO: Translate this during productization
					ariaLabel="Amount"
					showRangeLabels={showRangeLabels}
					showTooltip
					value={amount}
					onChange={onSliderChange}
					onChangeEnd={onSliderChangeEnd}
					minValue={minValue}
					maxValue={maxValue}
					formatValue={formatValue}
					fullWidth={fullWidth}
					name="amountSlider"
				/>
			</div>
			<div className="-mt-2">
				<AmountInput
					currencySymbol={currencySymbol}
					errorMessage={errorMessage}
					onChange={onInputChange}
					onFocus={onInputFocus}
					value={amount}
					placeholder={placeholder}
					height="56px"
				/>
			</div>
			<ValidationErrorMessage />
		</div>
	);
}
